var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.960449,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5156 21.4611H20.849V14.1694L15.849 17.2944L10.849 14.1694V21.4611H9.18229V11.4611H10.1823L15.849 15.0028L21.5156 11.4611H22.5156M22.5156 9.79443H9.18229C8.25729 9.79443 7.51562 10.5361 7.51562 11.4611V21.4611C7.51562 21.9031 7.69122 22.3271 8.00378 22.6396C8.31634 22.9522 8.74026 23.1278 9.18229 23.1278H22.5156C22.9577 23.1278 23.3816 22.9522 23.6941 22.6396C24.0067 22.3271 24.1823 21.9031 24.1823 21.4611V11.4611C24.1823 11.0191 24.0067 10.5951 23.6941 10.2826C23.3816 9.97003 22.9577 9.79443 22.5156 9.79443Z",
    fill: "black",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/Gmail.aa8ac9f28105ceec3856327625ae55b2.svg";
export { ForwardRef as ReactComponent };